var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrendDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 4,
    fill: "#D03325",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7876 13.5C14.5429 13.5 14.2983 13.4111 14.1052 13.2207L9.53433 8.71316L8.1309 10.7955C7.97639 11.0367 7.70601 11.1891 7.42275 11.2145C7.12661 11.2399 6.84335 11.1383 6.65021 10.9352L2.53004 6.87207C2.15665 6.50385 2.15665 5.89438 2.53004 5.52616C2.90343 5.15795 3.52146 5.15795 3.89485 5.52616L7.17811 8.76395L8.58155 6.68161C8.73605 6.45306 8.99356 6.30069 9.2897 6.2626C9.58584 6.23721 9.8691 6.33878 10.0622 6.54194L15.47 11.8748C15.8433 12.243 15.8433 12.8524 15.47 13.2207C15.2768 13.4111 15.0322 13.5 14.7876 13.5Z",
    fill: "#D03325"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7857 13.5H12.2143C11.6871 13.5 11.25 13.0629 11.25 12.5357C11.25 12.0086 11.6871 11.5714 12.2143 11.5714H13.8214V9.96429C13.8214 9.43714 14.2586 9 14.7857 9C15.3129 9 15.75 9.43714 15.75 9.96429V12.5357C15.75 13.0629 15.3129 13.5 14.7857 13.5Z",
    fill: "#D03325"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendDown);
export default __webpack_public_path__ + "static/media/trendDown.cb106d84045f362b93f0dad593d9d88d.svg";
export { ForwardRef as ReactComponent };